import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content container">
        <div className="hero-text">
          <h1 className="hero-title">
            ТВОЯ СИЛА.<br/>
            ТВОИ ПРАВИЛА.<br/>
            <span className="highlight">ТВОЙ РЕЗУЛЬТАТ.</span>
          </h1>
          <p className="hero-subtitle">
            Перестань мечтать. Начни действовать. FitHousse — это не просто тренировки.<br/>
            Это твоя трансформация под руководством AI и поддержкой тысяч единомышленников.
          </p>
          <div className="hero-cta">
            <Link to="/app" className="btn-primary">Начать Трансформацию</Link>
            <a href="#features" className="btn-secondary">Узнать Больше</a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">10K+</span>
              <span className="stat-label">Активных пользователей</span>
            </div>
            <div className="stat">
              <span className="stat-number">500+</span>
              <span className="stat-label">Видео тренировок</span>
            </div>
            <div className="stat">
              <span className="stat-number">98%</span>
              <span className="stat-label">Достигают целей</span>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <span>Листай вниз</span>
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
